var _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgByetECff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_9_2289",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0C0.895431 0 0 0.89543 0 2V11C0 12.1046 0.89543 13 2 13H8.88013L11.2491 16.0003L13.709 13H16C17.1046 13 18 12.1046 18 11V2C18 0.895431 17.1046 0 16 0H2Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.88013 13L10.0574 12.0705L9.60696 11.5H8.88013V13ZM11.2491 16.0003L10.0719 16.9298L11.2271 18.3929L12.4091 16.9513L11.2491 16.0003ZM13.709 13V11.5H12.9992L12.5491 12.049L13.709 13ZM1.5 2C1.5 1.72386 1.72386 1.5 2 1.5V-1.5C0.0670036 -1.5 -1.5 0.0670031 -1.5 2H1.5ZM1.5 11V2H-1.5V11H1.5ZM2 11.5C1.72386 11.5 1.5 11.2761 1.5 11H-1.5C-1.5 12.933 0.0670031 14.5 2 14.5V11.5ZM8.88013 11.5H2V14.5H8.88013V11.5ZM12.4264 15.0707L10.0574 12.0705L7.70287 13.9295L10.0719 16.9298L12.4264 15.0707ZM12.5491 12.049L10.0892 15.0492L12.4091 16.9513L14.869 13.951L12.5491 12.049ZM16 11.5H13.709V14.5H16V11.5ZM16.5 11C16.5 11.2761 16.2761 11.5 16 11.5V14.5C17.933 14.5 19.5 12.933 19.5 11H16.5ZM16.5 2V11H19.5V2H16.5ZM16 1.5C16.2761 1.5 16.5 1.72386 16.5 2H19.5C19.5 0.067004 17.933 -1.5 16 -1.5V1.5ZM2 1.5H16V-1.5H2V1.5Z",
    fill: "#32239B",
    mask: "url(#path-1-inside-1_9_2289)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgByetECff);
export default __webpack_public_path__ + "static/media/ByetECff.94995e3031d42e2ae75b2de76d4ace37.svg";
export { ForwardRef as ReactComponent };